import { render } from "./companylist.vue?vue&type=template&id=4e0f23b6"
import script from "./companylist.vue?vue&type=script&lang=js"
export * from "./companylist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__